<template>
  <div class="navbar">
    <div class="breadcrumb">
      <div class="is_collapse" @click="hideMenu">
        <i v-if="!collapse" class="el-icon-s-fold"></i>
        <i v-else class="el-icon-s-unfold"></i>
      </div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="(item, index) in list" :key="index">{{ item.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="userinfo">
      <!-- <el-color-picker v-model="themeColor" size="small" @change="handleColorChange"></el-color-picker> -->
      <div class="user">
        <el-avatar size="small" :src="avatar" @click="showInfo"></el-avatar>
        <div class="name" @click="showInfo">{{ uinfo?.userName }}</div>
      </div>
      <div class="exit" @click="logout">
        <i class="el-icon-switch-button"></i>
        <span>退出</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
    },
    collapse: {
      type: Boolean,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      avatar: require("@/assets/img/avatar.png"),
      uinfo: null,
      themeColor: "#A32126",
    }
  },
  created() {
    this.uinfo = this.$store.state.userInfo || null
  },
  methods: {
    handleColorChange(color) {},
    showInfo() {
      this.$emit("personal")
    },
    hideMenu() {
      this.$emit("change")
    },
    logout() {
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login")
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped lang="scss">
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 70px;
  padding-right: 20px;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

  .breadcrumb {
    display: flex;
    align-items: center;

    .is_collapse {
      color: #171717;
      padding: 20px;
      margin-right: 10px;
      font-size: 20px;
      cursor: pointer;

      &:hover {
        opacity: 0.6;
      }
    }

    .el-breadcrumb {
      font-size: 15px;
    }
  }

  .userinfo {
    display: flex;
    align-items: center;
    font-size: 15px;

    div:not(:first-child) {
      margin-left: 30px;
    }

    .user {
      display: flex;
      align-items: center;
      cursor: pointer;

      .name {
        margin-left: 12px;
      }
    }

    .exit {
      color: $themes;
      cursor: pointer;

      &:hover {
        opacity: 0.6;
      }
    }
  }
}
</style>
